import { useDispatch, useSelector } from 'react-redux';
import { setSelectedDate, setFilters } from 'src/pages/home/redux/actions';
import { convertDateToISOString } from 'src/utils/util';
import { getEndDateForStartDate, getEndOfTimeDate } from 'src/utils/dateUtils';

const useCalendarHeaderNavigation = () => {
    const dispatch = useDispatch();
    const selectedDate = useSelector((state) => state.filterReducer.selectedDate);

    const toggleWeek = (toggleType) => {
        const newMinDate = new Date(selectedDate);
        if (toggleType === 'next') {
            newMinDate.setDate(newMinDate.getDate() + 7);
        }
        if (toggleType === 'previous') {
            newMinDate.setDate(newMinDate.getDate() - 7);
        }
        const newStartDate = newMinDate;
        const isFutureOrToday = newStartDate.getTime() >= new Date().setHours(0, 0, 0, 0);
        let newEndDate;
        if (isFutureOrToday) {
            newEndDate = getEndOfTimeDate();
        } else {
            // Extend endDate to end of the week (Saturday) so userFilters always
            // covers the full 7-day visible range after navigation.
            const dayOfWeek = newStartDate.getDay();
            const daysUntilSaturday = 6 - dayOfWeek;
            newEndDate = getEndDateForStartDate(new Date(newStartDate), daysUntilSaturday);
        }
        dispatch(setSelectedDate(new Date(newStartDate)));
        dispatch(
            setFilters({
                startDate: convertDateToISOString(new Date(newStartDate), 'start'),
                endDate: convertDateToISOString(newEndDate, 'end'),
            })
        );
    };

    const toggleMonth = (toggleType) => {
        const newMonthDate = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            1
        );
        if (toggleType === 'next') {
            newMonthDate.setMonth(selectedDate.getMonth() + 1);
        }
        if (toggleType === 'previous') {
            newMonthDate.setMonth(selectedDate.getMonth() - 1);
        }
        const newSelectedDate = new Date(newMonthDate);
        newSelectedDate.setDate(
            newSelectedDate.getDate() - (newSelectedDate.getDate() - 1)
        );
        const newStartDate = new Date(newSelectedDate);
        const newEndDate =
            newStartDate.getTime() >= new Date().setHours(0, 0, 0, 0)
                ? getEndOfTimeDate()
                : getEndDateForStartDate(new Date(newStartDate), 0);
        dispatch(setSelectedDate(new Date(newStartDate)));
        dispatch(
            setFilters({
                startDate: convertDateToISOString(new Date(newStartDate), 'start'),
                endDate: convertDateToISOString(new Date(newEndDate), 'end'),
            })
        );
    };

    return { toggleWeek, toggleMonth };
};

export default useCalendarHeaderNavigation;
